
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    display: block;
}

:host([bg-color='dark']) {

    border-radius: 0.75rem;

    background-color: var(--primary-blue);

    color: var(--neutral-white);
}

:host([bg-color='dark']) .heading * {

    color: var(--neutral-white);
}

:host([bg-color='light-blue']) {

    border-radius: 0.75rem;

    background-image: var(--light-blue-gradient);

    color: var(--primary-blue);
}

:host([bg-color='white']) {

    border-radius: 0.75rem;

    background-color: var(--neutral-white);

    color: var(--primary-blue);
}

:host([bg-color='']) {

    border-radius: 0.75rem;

    background-color: var(--neutral-transparent);
}

:host([site='BH']) {

    font-family: var(--bh-ff-body);
}

:host([site='BH'][bg-color='light-blue']) {

    background-image: var(--bh-gradient-lightblue-bl-tr);

    color: var(--bh-brand-primary-dark);
}

:host([site='BH'][bg-color='white']) {

    background-color: var(--bh-neutral-white);

    color: var(--bh-brand-primary-dark);
}

:host([site='BH'][bg-color='dark']) {

    background-color: var(--bh-brand-primary-dark);

    color: var(--bh-neutral-white);
}
`;